import React from "react";
import Tooltip from "@mui/material/Tooltip";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import {useShallow} from "zustand/react/shallow";
import {useSavedDealershipsStore} from "../../stores/savedDealershipsStore";
import {useThemeStore} from "../../stores/themeStore";

// Toggle to save / un-save a dealership. Used on vehicle cards, the listing
// detail dealer block, and the map InfoWindow header. Inline-styled so it
// renders correctly even inside the (portaled) InfoWindow, outside the page's
// scoped CSS.
export function SaveDealershipButton({dealership, size = 20}) {
    const isDark = useThemeStore((state) => state.theme === 'dark')
    const {saved, saveDealership, removeDealership} = useSavedDealershipsStore(
        useShallow((state) => ({
            saved: state.saved,
            saveDealership: state.saveDealership,
            removeDealership: state.removeDealership,
        }))
    )

    const externalId = String(dealership?.id ?? dealership?.external_id ?? '')
    const savedRecord = saved.find(d => String(d.external_id) === externalId)
    const isSaved = Boolean(savedRecord)

    if (!externalId) return null

    const toggle = (e) => {
        e.stopPropagation()
        if (isSaved) removeDealership(savedRecord.id)
        else saveDealership(dealership)
    }

    const color = isSaved ? '#f5a623' : (isDark ? '#8b95a8' : '#8a8f9e')
    const label = isSaved ? 'Remove saved dealership' : 'Save dealership'

    return (
        <Tooltip title={label} arrow slotProps={{popper: {sx: {zIndex: 11000}}}}>
            <button
                type="button"
                onClick={toggle}
                aria-label={label}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: 'none',
                    background: 'transparent',
                    padding: 2,
                    cursor: 'pointer',
                    color,
                    lineHeight: 0,
                }}
            >
                {isSaved
                    ? <BookmarkIcon style={{fontSize: size}}/>
                    : <BookmarkBorderIcon style={{fontSize: size}}/>}
            </button>
        </Tooltip>
    )
}
